import React from "react";
import PropTypes from "prop-types";

const VariantSummary = ({ label, variantSummary }) => {
  return variantSummary ? (
    <div className="varsome-horiz-list-item">
      <div className="varsome-horiz-list-label">{label}</div>
      <div className="varsome-horiz-list-value">{variantSummary}</div>
    </div>
  ) : null;
};

VariantSummary.propTypes = {
  label: PropTypes.string,
  variantSummary: PropTypes.string,
};

VariantSummary.defaultProps = {
  label: null,
  variantSummary: null,
};

export default VariantSummary;
